import { method } from 'lodash';
import {
  apiDefaultWithoutToken,
  apiDefaultWithoutTokenWithUrlencodedType,
  apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll
} from './api';

const prefix = '/_ui/responsive/theme-trplus/app/src/js/controller/Json';
// const prefixUat = 'https://uatbe.trplus.com.tw';
// const prefixProduction = 'https://www.trplus.com.tw';

// header
export const apiGetCommonHeaderAD = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/category/menu', data);
export const apiGetIndexMiniCartJson = (method) => apiDefaultWithoutToken[method]('/cart/miniCartList');
export const apiGetIndexMemberPoints = (method) => apiDefaultWithoutToken[method]('/my-account/getpoint');
export const apiGetIndexMenuSubMenuData = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/category/menu', data);
export const apiGetMobileMenuData = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/category/mobileMenu', data);
// footer
export const apiGetMobileFooter = (method) => apiDefaultWithoutTokenWithUrlencodedType[method]('/mobileFooter');
// search
export const apiGetAutoCompleteSearch = (method, data) => apiDefaultWithoutToken[method](
  `/search/autocomplete?Action=GetAutoCompleteTerms&results=100&query=1&prefix=${data}`,
);
// product
// /p/deleteBrowsedProduct?productCode=014126558 刪單品
// /p/deleteBrowsedProduct?type=all 全刪
export const apiPostDeleteAllBrowserProduct = (method, data) => apiDefaultWithoutToken[method]('/p/deleteBrowsedProduct', data);
export const apiPostDeleteBrowserProduct = (method, sku) => apiDefaultWithoutToken[method]('/p/deleteBrowsedProduct', sku);
export const apiGetSimpleProductData = (method, sku) => apiDefaultWithoutToken[method](`/rest/v2/trplus/productList?skus=${sku}`);
export const apiGetPointOfServices = (method, sku, data) => apiDefaultWithoutToken[method](`/store-pickup/${sku}/pointOfServices`, data);
export const apiGetCouponListForProduct = (method, sku) => apiDefaultWithoutToken[method](`/query/couponListForProduct?productCode=${sku}`);
export const apiPostAddToFavorite = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/customerTracking/add', data);
export const apiPostRemoveToFavorite = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/customerTracking/remove', data);
export const apiPostAddToCart = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/cart/add', data);
export const apiPostAddWriteReview = (method, sku, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/p/${sku}/writeReview`, data);
export const apiPostAddProductArrivalNotice = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/customerProductArrivalNotice/add`, data);
export const apiPostRemoveProductArrivalNotice = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/customerProductArrivalNotice/remove`, data);

// 品牌旗艦頁分類串接api
export const apiGetCategoryData = (method, data) => apiDefaultWithoutToken[method]('/c/getCategoryData', data, {timeout: 10000});

// 和樂改版搜尋結果頁串接api
export const apiGetSearchData = (method, data) => apiDefaultWithoutToken[method]('/search/getSearchProductData', data, {timeout: 10000});

//一對一文字客服
export const apiPostOpenWebChat = (data) => apiDefaultWithoutToken.get(`/openWebChat${data ? `?pCode=${data}`: ''}`);

// cart
export const apiGetCartListData = (method, data) => apiDefaultWithoutToken[method]('/cart/cartList', data);
export const apiPostUpdateCart = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/cart/update', data);
// mini cart
export const apiGetMiniCartListData = (method, data) => apiDefaultWithoutToken[method]('/cart/miniCartList', data);
// 取得會員點數
export const apiGetMemberPoints = (method, data) => apiDefaultWithoutToken[method]('/my-account/getpoint', data);
// 使用會員點數
export const apiPostUseMemberPoints = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/voucher/pointexchange?point=${data.point}`, data.cSRFToken);
// 移除使用會員點數
export const apiPostDeleteMemberPoints = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/point/remove`, data.cSRFToken);
// 使用折價卷
export const apiPostUseCouponCode = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/voucher/apply?code=${data.code}`, data.cSRFToken);
// 移除使用折價卷
export const apiPostDeleteCouponCode = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/voucher/remove?code=${data.code}`, data.cSRFToken);
// 取得整個購物車折價卷
export const apiGetUseCoupon = (method, data) => apiDefaultWithoutToken[method](`/query/couponList`, data);
// 取得某個商品可用折價卷
export const apiGetProductCoupon = (method, productCode) => apiDefaultWithoutToken[method](`/query/couponListForEntry?productCode=${productCode}`);
// 使用某個商品的折價卷
export const apiPostUseProductCoupon = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/productcoupon/apply`, data);
// 移除某個商品的折價卷
export const apiPostDeleteProductCoupon = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/productcoupon/remove`, data);
// 使用某個商品安運服務
export const apiPostAddInstallation = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/installation/apply`, data);
// 移除使用某個商品安運服務
export const apiPostRemoveInstallation = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/installation/remove`, data);
// 購物車取得門市取貨資料
export const apiPostCartPointOfService = (method, sku, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/store-pickup/${sku}/pointOfServices`, data);
export const apiPostCartStorePickAddQuantity = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/store-pickup/cart/add`, data);
// 購物車加盟店使用點數
export const apiPostApplyCartFranchise = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/franchisee/apply`, data);
// 購物車加盟店取消使用點數
export const apiPostRemoveCartFranchise = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method](`/cart/franchisee/remove`, data);
// 購物車任選移除商品確認
export const apiPostRemoveZoneCart = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/cart/checkRemove', data);

// 結帳頁
export const apiGetAddressBook = (method) => apiDefaultWithoutToken[method]('/checkout/shopping-info/addressBooks');
export const apiPostPlaceOrder = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/checkout/info/process/placeOrder', data);
export const apiPostUpdateDeliveryAddress = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method]('/checkout/info/process/updateDeliveryAddr', data);
// 取得5碼郵遞區號、確認是否是服務範圍
export const apiGetFivePostalCode = (requestDataString) => apiDefaultWithoutToken.get(`/checkout/info/process/zipCode?${requestDataString}`);

// member
export const apiPostTrpayDeposit = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/memberBonus/trpayDeposit', data);

// 訂單
export const apiGetOrderListDetail = (method, orderInfo) => apiDefaultWithoutToken[method](`/my-account/Brieforder/${orderInfo.ordercode}?ordersource=${orderInfo.thischanel}`);
export const apiPostRefreshOrder = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/guest/refreshOrder`, data);
export const apiPostGetEntryNumbers = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/guest/getEntryNumbers`, data);
export const apiGetReturnOrRefund = (method, paramsData) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/guest/getReturnOrRefund?orderCode=${paramsData.orderCode}&entryNumber=${paramsData.orderEntries}`);
export const apiPostOrderReturn = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/guest/order-return`, data, {timeout: 30000});
export const apiGetReturnBankIDWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/orderBank.json`);
export const apiGetReturnRequestB2B = (method, data) => apiDefaultWithoutTokenWithUrlencodedTypeAcceptAll[method](`/my-account/rtvStatusJson?code=${data}`, {timeout: 30000});
export const apiPostAddTaxID = (data) => apiDefaultWithoutTokenWithUrlencodedType.post(`/my-account/editInvoiceType`, data);

// instagram資料
export const apiGetInstagramData = (method, id) => apiDefaultWithoutToken[method](`/igCallBack/getDetail?id=${id}`);

// 任選加入購物車
export const apiPostZoneProductAddToCart = (method, data) => apiDefaultWithoutTokenWithUrlencodedType[method]('/cart/addZoneRule', data);

export const apiGetProductInfoData = (data) => apiDefaultWithoutToken.get('/app/rest/v2/product/productInfo', data);
export const apiPostCouponListForProduct = (data) => apiDefaultWithoutTokenWithUrlencodedType.post('/query/couponListForProduct', data);
export const apiGetArPathUrl = (productCode) => apiDefaultWithoutToken.get(`/QRCode/getArUrl?productCode=${productCode}`)

// 取得保固資料
export const apiGetWarranties = (data) => apiDefaultWithoutToken.get("/my-account/getWarranties", { params: data });


// 取得組促群組分頁 api
export const apiPostGetPromotionProductList = (data) =>
  apiDefaultWithoutToken.post("/rest/v2/trplus/productList", data);
export const apiGetCheckProductValidList = (skus) =>
  apiDefaultWithoutToken.get("/app/v4/cart/checkProductValidList", {
    params: { skus },
  });
export const apiPostCheckPromotionValid = (data) =>
  apiDefaultWithoutToken.post("/app/v4/cart/checkPromotionValid", data);

// common 通用
// 取得收藏數量
export const apiGetProductTrackingNum = () => apiDefaultWithoutToken.get("/customerTracking/productTrackingNum");

// for 地端測試資料 json
// tlwIndex
// export let apiGetTlwIndexDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/TLWIndex.json`);
// holaIndex
// export let apiGetHolaIndexDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/HOLAIndex.json`);
// hoiIndex
// export let apiGetHoiIndexDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/HOIIndex.json`);
// cbIndex
// export let apiGetCbIndexDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/CBAIndex.json`);
// product
// export let apiGetProductDataWithJson = (method, sku) => apiDefaultWithoutToken[method](`${prefix}/Products/${sku}.json`);
// footer
// export let apiGetFooterDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/Footer.json`);
// footer production API 通道測試
// export let apiGetFooterDataProduction = (method) => apiDefaultWithoutToken[method](`${prefix}/dd.json`);
// index
// export let apiGetTrplusNavDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/Header.json`);
// export let apiGetIndexDataWithJson = (method) => apiDefaultWithoutToken[method](`${prefix}/Index.json`);
